import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { DetailsOverviewComponent } from '@app/shared/components/ui-components/details-overview/details-overview/details-overview.component'
import { SharedModule } from '@app/shared/shared.module'
import { ScopeOverviewHeaderComponent } from '../components/scope-overview/scope-overview-header/scope-overview-header.component'
import { ChangeRequestContainerComponent } from './components/change-request-container.component'
import { ChangeRequestComponent } from './components/change-request.component'
import { ChangeRequestNgrxModule } from './change-request-ngrx.module'
import { ChangeRequestApprovalFlowComponent } from './components/change-request-approval-flow/change-request-approval-flow.component'
import { DirectivesModule } from '@app/shared/directives/index.module'
import { ChangeRequestTooltipComponent } from './components/change-request-tooltip/change-request-tooltip.component'
import { ChangeRequestOverviewComponent } from './components/change-request-overview/change-request-overview.component'
import { ChangeRequestTrackedComponent } from './components/change-request-tracked/change-request-tracked.component'
import { ChangeRequestListComponent } from './components/change-request-list/change-request-list.component'
import { ScopeTabComponent } from '../components/scope-tab/scope-tab.component'
import { ScopeByWorkTableComponent } from '../components/scope-overview/scope-by-work-table/scope-by-work-table.component'
import { ScopeUiTabsComponent } from '@app/shared/components/ui-components/scope-ui-tabs/scope-ui-tabs.component'
import { ScopeUiTabComponent } from '@app/shared/components/ui-components/scope-ui-tab/scope-ui-tab.component'
import { ScopeUiOptionsMenuComponent } from '@app/shared/components/scope-ui-options-menu/scope-ui-options-menu.component'
import { ChangeRequestRebaseModalComponent } from './components/change-request-rebase-modal/change-request-rebase-modal.component'

@NgModule({
  declarations: [
    ChangeRequestContainerComponent,
    ChangeRequestComponent,
    ChangeRequestTooltipComponent,
    ChangeRequestApprovalFlowComponent,
    ChangeRequestOverviewComponent,
    ChangeRequestTrackedComponent,
    ChangeRequestListComponent,
    ChangeRequestRebaseModalComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    DirectivesModule,
    ChangeRequestNgrxModule,
    ScopeOverviewHeaderComponent,
    DetailsOverviewComponent,
    ScopeTabComponent,
    ScopeByWorkTableComponent,
    ScopeUiTabsComponent,
    ScopeUiTabComponent,
    ScopeUiOptionsMenuComponent,
  ],
})
export class ChangeRequestModule {}
